import { MenuItemFragment } from "../graphql/types";

export interface MenuItemWithIndex {
  index: number;
  item: MenuItemFragment;
}

export function findChildrenMenuItemsOf(allItems: MenuItemFragment[], parentIndex: number): MenuItemWithIndex[] {
  const out: MenuItemWithIndex[] = [];
  allItems.forEach((item, index) => {
    if (item.parent_index !== parentIndex) return;
    out.push({
      item,
      index,
    });
  });
  return out;
}
